import { render, staticRenderFns } from "./BusinessProgramManage.vue?vue&type=template&id=1542e750&scoped=true"
import script from "./BusinessProgramManage.vue?vue&type=script&lang=js"
export * from "./BusinessProgramManage.vue?vue&type=script&lang=js"
import style0 from "./BusinessProgramManage.vue?vue&type=style&index=0&id=1542e750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1542e750",
  null
  
)

export default component.exports